// src/hooks/useCurrency.js
import { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/config";

const DEFAULT_CURRENCY = { code: "EUR", symbol: "€", name: "Euro" };

export function useCurrency() {
  const { userId } = useAuth();
  const [currency, setCurrency] = useState(DEFAULT_CURRENCY);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) {
      setCurrency(DEFAULT_CURRENCY);
      setLoading(false);
      return;
    }

    const fetchCurrency = async () => {
      try {
        const settingsDocRef = doc(db, "users", userId, "settings", "currency");
        const docSnap = await getDoc(settingsDocRef);

        if (docSnap.exists() && docSnap.data().currency) {
          setCurrency(docSnap.data().currency);
        }
      } catch (error) {
        console.error("Error fetching currency:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCurrency();
  }, [userId]);

  const formatCurrency = (amount) => {
    if (amount === undefined || amount === null) return "";

    const formattedAmount = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);

    return `${currency.symbol}${formattedAmount}`;
  };

  return {
    currency,
    formatCurrency,
    loading,
  };
}
